export default __webpack_public_path__ + "static/media/ic-mint.dbcd686f.dbcd686f.svg";